// extracted by mini-css-extract-plugin
module.exports = {"root":"ViewItem_root__18lvs","description":"ViewItem_description__1SacU"};